module.exports = __webpack_public_path__ + "static/media/kaomoji1.9b189029.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/img/project/kaomoji/kaomoji1.png
// module id = 362
// module chunks = 0